export default {
  confirm: 'Vahvista',
  title: 'Soveltuvat tarjoukset',
};
